import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharingDataService {
  startDate: Date;
  endDate: Date;
}
